import { graphql } from 'gatsby';
import React from 'react';

import { TripPlannerQuery } from '../../../graphql-types';
import { TPageProps } from '../../page-props';
import TripPlannerPage from '../../templates/trip-planner';

export default (props: TPageProps<TripPlannerQuery>) => <TripPlannerPage {...props} />;

export const query = graphql`
  query TripPlanner {
    allBikeRoute {
      nodes {
        data {
          ...BikeRouteData
        }
      }
    }
  }
`;
